if (!customElements.get('card-product')) {
  class CardProduct extends HTMLElement {
    constructor() {
      super();

      if (this.classList.contains('disabled')) {
        return;
      }

      this.swatches = this.querySelector('.js-swatches');
      this.btnToggleSizes = this.querySelector(
        '.js-btn-toggle-sizes'
      );
      this.defaultMedia = this.querySelector('.js-media-default');

      if (this.btnToggleSizes) {
        this.cartDrawer = document.querySelector('cart-drawer');

        this.duplicateSizes();
        this.setAccessibility();

        this.initialSizeBtns =
          this.sizesContent.querySelectorAll('.js-btn-size');
        this.duplicateSizeBtns =
          this.duplicatedSizesContent.querySelectorAll(
            '.js-btn-size'
          );
        this.sizeBtns = [
          ...this.initialSizeBtns,
          ...this.duplicateSizeBtns
        ];

        this.btnToggleSizes.addEventListener('click', e => {
          e.preventDefault();

          if (!this.duplicatedSizesContainer) {
            return;
          }

          const btnId = this.btnToggleSizes.dataset.id;
          const sizesContent =
            this.duplicatedSizesContainer.querySelector(
              `.js-sizes-content[data-id="${btnId}"]`
            );

          this.openQuickAddModal(sizesContent);
        });

        this.duplicatedSizesContent.addEventListener('click', e => {
          const isSizesContent = e.target.classList.contains(
            'js-sizes-content'
          );

          if (!isSizesContent) {
            return;
          }

          const sizesContent = e.target;

          this.hideSizes(sizesContent);
        });

        this.duplicatedSizesContent.addEventListener('keydown', e => {
          const isEscape = e.key === 'Escape';

          if (!isEscape) {
            return;
          }

          this.hideSizes(this.duplicatedSizesContent);
        });

        this.duplicatedSizesContent.addEventListener('keydown', e => {
          const isTabKey = e.key === 'Tab';

          if (!isTabKey) {
            return;
          }

          const isFirstElementFocused =
            document.activeElement === this.firstFocusableElement;
          const isLastElementFocused =
            document.activeElement === this.lastFocusableElement;

          if (e.shiftKey && isFirstElementFocused) {
            this.lastFocusableElement.focus();

            e.preventDefault();
          } else if (!e.shiftKey && isLastElementFocused) {
            this.firstFocusableElement.focus();

            e.preventDefault();
          }
        });

        window.addEventListener('resize', () => {
          const isMobile = window.innerWidth < mobileWidth;
          const isSizeContentVisible =
            this.duplicatedSizesContent.classList.contains(
              'is-visible'
            );
          const hasHover = matchMedia('(hover: hover)').matches;

          if (isMobile || !isSizeContentVisible || !hasHover) {
            return;
          }

          this.hideSizes(this.duplicatedSizesContent);
        });

        this.sizesContent.addEventListener(
          'click',
          this.handleBtnSizeClick.bind(this)
        );
        this.duplicatedSizesContent.addEventListener(
          'click',
          this.handleBtnSizeClick.bind(this)
        );
      }

      if (this.swatches) {
        this.btnSwatches =
          this.swatches.querySelectorAll('.js-btn-swatch');

        this.swatches.addEventListener('change', e => {
          const isBtnSwatch =
            e.target.classList.contains('js-btn-swatch');

          if (!isBtnSwatch) {
            return;
          }

          const btnSwatch = e.target;
          const isSwatchActive =
            btnSwatch.classList.contains('is-active');

          if (isSwatchActive) {
            return;
          }

          const btnSwatchColor = btnSwatch.dataset.color;
          const btnSwatchColorSelector = btnSwatchColor.toLowerCase();
          const btnSwatchColorHyphenated = btnSwatchColorSelector.replace(' ', '-');

          const activeBtnSwatch = this.swatches.querySelector(
            '.js-btn-swatch.is-active'
          );

          const currentVisibleMedia = this.querySelector(
            '[class*="js-media"].is-visible'
          );
          const newVisibleMedia = this.querySelector(
            `.js-media-${btnSwatchColorHyphenated}`
          );

          activeBtnSwatch.classList.remove('is-active');
          btnSwatch.classList.add('is-active');

          if (newVisibleMedia) {
            currentVisibleMedia.classList.remove('is-visible');
            newVisibleMedia.classList.add('is-visible');
          } else if (this.defaultMedia) {
            currentVisibleMedia.classList.remove('is-visible');
            this.defaultMedia.classList.add('is-visible');
          }

          if (!this.btnToggleSizes) {
            return;
          }

          const sizeMessagesContainer =
            this.sizesContent.querySelector(
              '.js-messages.is-visible'
            );

          sizeMessagesContainer?.classList.remove('is-visible');

          const isRequesting =
            this.classList.contains('is-requesting');

          if (isRequesting) {
            return;
          }

          this.toggleBtns();

          const updateAvailableSizes = async () => {
            try {
              const product = await this.getProduct();

              const matchingColorVariants = product.variants.filter(
                variant => variant.options.includes(btnSwatchColor)
              );

              this.sizeBtns.forEach(sizeBtn => {
                const size = sizeBtn.dataset.size;
                const matchingSizeVariant =
                  matchingColorVariants.find(matchingColorVariant =>
                    matchingColorVariant.options.includes(size)
                  );

                if (
                  matchingSizeVariant &&
                  matchingSizeVariant.available
                ) {
                  sizeBtn.setAttribute('aria-disabled', false);
                  sizeBtn.classList.remove('is-disabled');

                  return;
                }

                sizeBtn.setAttribute('aria-disabled', true);
                sizeBtn.classList.add('is-disabled');
              });
            } catch (error) {
              console.error(error);
            } finally {
              this.toggleBtns();
            }
          };

          updateAvailableSizes();
        });
      }
    }

    async getProduct() {
      try {
        const productResponse = await fetch(
          `${window.Shopify.routes.root}products/${this.dataset.handle}.js`
        );

        const product = await productResponse.json();

        return product;
      } catch (error) {
        console.error(error);
      }
    }

    duplicateSizes() {
      this.sizesContent = this.querySelector('.js-sizes-content');
      this.duplicatedSizesContent = this.sizesContent.cloneNode({
        deep: true
      });
      this.duplicatedSizesContainer = document.querySelector(
        '.js-card-sizes-duplicate'
      );

      this.focusableElements = getFocusableElements(
        this.duplicatedSizesContent
      );

      this.firstFocusableElement = this.focusableElements[0];
      this.lastFocusableElement =
        this.focusableElements[this.focusableElements.length - 1];

      if (!this.duplicatedSizesContainer) {
        this.duplicatedSizesContainer = document.createElement('div');
        this.duplicatedSizesContainer.classList.add(
          'js-card-sizes-duplicate'
        );

        document.body.insertAdjacentElement(
          'beforeend',
          this.duplicatedSizesContainer
        );
      }

      this.duplicatedSizesContainer.insertAdjacentElement(
        'beforeend',
        this.duplicatedSizesContent
      );
    }

    async openQuickAddModal(sizesContent) {
      this.btnToggleSizes.setAttribute('aria-expanded', true);
      sizesContent.classList.add('is-visible');
      document.body.style.overflow = 'hidden';

      const itemsContainer = sizesContent.querySelector('.card-product__sizes-items');
      const existingForm = itemsContainer?.querySelector('.quick-add-form');
      const list = itemsContainer?.querySelector('ul');

      sizesContent.classList.add('overlay-visible');

      try {
        const product = await this.getProduct();
        if (!product) {
          sizesContent.classList.remove('overlay-visible');
          this.hideSizes(sizesContent);
          return;
        }

        const form = this.buildQuickAddForm(product, sizesContent);
        if (form) {
          if (existingForm) {
            existingForm.replaceWith(form);
          } else if (list) {
            list.replaceWith(form);
          }
        }
      } catch (err) {
        console.error(err);
      } finally {
        sizesContent.classList.remove('overlay-visible');
      }

      this.focusableElements = getFocusableElements(this.duplicatedSizesContent);
      this.firstFocusableElement = this.focusableElements[0];
      this.lastFocusableElement = this.focusableElements[this.focusableElements.length - 1];
      this.firstFocusableElement?.focus();
    }

    getVariantImageUrl(variant, product) {
      if (!variant && !product) return '';
      const feat = variant?.featured_image || variant?.featured_media?.preview_image || variant?.image || product?.featured_image || product?.featured_media?.preview_image;
      if (!feat) return '';
      if (typeof feat === 'string') return feat;
      return feat.src || feat.url || (feat.preview_image && (feat.preview_image.src || feat.preview_image.url)) || '';
    }

    normalizeImageUrlForCompare(url) {
      if (!url || typeof url !== 'string') return '';
      try {
        const u = url.indexOf('//') === 0 ? 'https:' + url : url;
        const path = u.split('?')[0].split('#')[0];
        return path.replace(/\/$/, '');
      } catch (_) {
        return url;
      }
    }

    buildQuickAddForm(product, modalContainer) {
      const addToCartLabel = this.dataset.addToCart || 'Add to cart';
      const unavailableLabel = this.dataset.unavailable || 'Unavailable';

      const form = document.createElement('div');
      form.className = 'quick-add-form';

      const closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.className = 'quick-add-form__close button-reset';
      closeBtn.setAttribute('aria-label', document.documentElement.lang === 'nl' ? 'Sluiten' : 'Close');
      closeBtn.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M18 6L6 18" stroke="currentColor" stroke-linecap="square"/><path d="M6 6L18 18" stroke="currentColor" stroke-linecap="square"/></svg>';
      closeBtn.addEventListener('click', () => this.hideSizes(modalContainer));
      form.appendChild(closeBtn);

      const optionsArray = this.normalizeProductOptions(product);
      const optionNames = optionsArray.map(o => o.name);
      const optionValuesByIndex = optionsArray.map(o => o.values);
      const hasMultipleOptions = product.variants?.length > 1 && optionNames.length > 0;

      const selectedOptions = [];

      const variantsWithImages = (product.variants || []).filter(v => this.getVariantImageUrl(v, product));
      const productImageUrl = this.getVariantImageUrl(null, product);
      const showVariantImages = variantsWithImages.length > 0 || productImageUrl;

      if (showVariantImages) {
        const mediaWrap = document.createElement('div');
        mediaWrap.className = 'quick-add-form__media';
        const mainImgWrap = document.createElement('div');
        mainImgWrap.className = 'quick-add-form__media-main';
        const mainImg = document.createElement('img');
        mainImg.className = 'quick-add-form__media-img';
        mainImg.alt = product.title || '';
        mainImg.loading = 'lazy';
        const defaultVariant = product.variants?.find(v => v.featured_image) || product.variants?.[0];
        mainImg.src = this.getVariantImageUrl(defaultVariant, product) || this.getVariantImageUrl(product.variants?.[0], product) || productImageUrl || '';
        mainImgWrap.appendChild(mainImg);

        const cardsWrap = document.createElement('div');
        cardsWrap.className = 'quick-add-form__media-cards';
        const uniqueByImage = new Map();
        (product.variants || []).forEach(v => {
          const url = this.getVariantImageUrl(v, product);
          const key = this.normalizeImageUrlForCompare(url);
          if (key && !uniqueByImage.has(key)) uniqueByImage.set(key, { url, variant: v });
        });
        uniqueByImage.forEach(({ url, variant }, key) => {
          const card = document.createElement('button');
          card.type = 'button';
          card.className = 'quick-add-form__media-card button-reset js-quick-add-media-card';
          card.dataset.variantId = String(variant.id);
          card.dataset.imageSrc = key;
          const img = document.createElement('img');
          img.src = url;
          img.alt = variant.title || product.title || '';
          img.loading = 'lazy';
          card.appendChild(img);
          cardsWrap.appendChild(card);
        });
        mediaWrap.appendChild(mainImgWrap);
        if (cardsWrap.children.length > 1) mediaWrap.appendChild(cardsWrap);
        form.appendChild(mediaWrap);
      }

      if (hasMultipleOptions) {
        optionNames.forEach((optionName, optionIndex) => {
          const values = optionValuesByIndex[optionIndex] || [];
          const optionWrap = document.createElement('div');
          optionWrap.className = 'product-selector__buttons quick-add-form__option';
          const label = document.createElement('legend');
          label.className = 'product-selector__label';
          label.textContent = optionName;
          optionWrap.appendChild(label);
          const valuesWrap = document.createElement('div');
          valuesWrap.className = 'product__swatches swatches';
          const list = document.createElement('ul');
          list.className = 'list-unstyled';

          values.forEach(value => {
            const li = document.createElement('li');
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'product__swatch product__swatch--button button-reset js-quick-add-option';
            btn.dataset.optionIndex = optionIndex;
            btn.dataset.optionValue = value;
            btn.textContent = value;
            li.appendChild(btn);
            list.appendChild(li);
          });
          valuesWrap.appendChild(list);
          optionWrap.appendChild(valuesWrap);
          form.appendChild(optionWrap);
          selectedOptions.push(null);
        });
      }

      const submitWrap = document.createElement('div');
      submitWrap.className = 'quick-add-form__submit-wrap';
      const submitBtn = document.createElement('button');
      submitBtn.type = 'button';
      submitBtn.className = 'button button--filled button--full button--uppercase quick-add-form__submit js-quick-add-submit';
      submitBtn.textContent = addToCartLabel;
      submitBtn.disabled = hasMultipleOptions;

      const unavailableEl = document.createElement('p');
      unavailableEl.className = 'quick-add-form__unavailable hidden';
      unavailableEl.textContent = unavailableLabel;

      const mainImgEl = form.querySelector('.quick-add-form__media-img');
      const mediaCards = form.querySelectorAll('.js-quick-add-media-card');

      const updateSubmitState = () => {
        let variant = null;
        if (!hasMultipleOptions && product.variants?.length === 1) {
          variant = product.variants[0];
        } else {
          const allSelected = selectedOptions.every(v => v != null);
          if (allSelected) {
            variant = product.variants.find(v =>
              v.options?.every((opt, i) => opt === selectedOptions[i])
            );
          }
        }
        let displayVariant = variant;
        if (!displayVariant && selectedOptions.some(v => v != null)) {
          displayVariant = (product.variants || []).find(v => {
            const opts = v.options || [v.option1, v.option2, v.option3].filter(Boolean);
            return selectedOptions.every((sel, i) => sel == null || opts[i] === sel);
          });
        }
        if (variant) {
          submitBtn.dataset.variantId = variant.id;
          submitBtn.disabled = !variant.available;
          unavailableEl.classList.toggle('hidden', variant.available);
          if (mainImgEl) {
            const src = this.getVariantImageUrl(variant, product);
            if (src) mainImgEl.src = src;
          }
        } else {
          submitBtn.disabled = true;
          submitBtn.removeAttribute('data-variant-id');
          unavailableEl.classList.add('hidden');
          if (mainImgEl && displayVariant) {
            const src = this.getVariantImageUrl(displayVariant, product);
            if (src) mainImgEl.src = src;
          }
        }
        const imageUrlForOutline = displayVariant ? this.getVariantImageUrl(displayVariant, product) : '';
        const normalizedForOutline = this.normalizeImageUrlForCompare(imageUrlForOutline);
        mediaCards.forEach(card => {
          const matchesImage = normalizedForOutline && card.dataset.imageSrc === normalizedForOutline;
          card.classList.toggle('is-active', !!matchesImage);
        });
        form.querySelectorAll('.js-quick-add-option').forEach(optBtn => {
          const idx = parseInt(optBtn.dataset.optionIndex, 10);
          const val = optBtn.dataset.optionValue;
          const available = this.isOptionValueAvailable(product, idx, val, selectedOptions);
          optBtn.disabled = !available;
          optBtn.classList.toggle('is-unavailable', !available);
        });
      };

      form.querySelectorAll('.js-quick-add-option').forEach(btn => {
        btn.addEventListener('click', () => {
          if (btn.disabled || btn.classList.contains('is-unavailable')) return;
          const idx = parseInt(btn.dataset.optionIndex, 10);
          const value = btn.dataset.optionValue;
          selectedOptions[idx] = value;
          form.querySelectorAll(`.js-quick-add-option[data-option-index="${idx}"]`).forEach(b => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          updateSubmitState();
        });
      });

      form.querySelectorAll('.js-quick-add-media-card').forEach(card => {
        card.addEventListener('click', () => {
          const variantId = card.dataset.variantId;
          const v = product.variants?.find(vr => String(vr.id) === variantId);
          if (!v?.options) return;
          v.options.forEach((optVal, i) => {
            selectedOptions[i] = optVal;
            const btn = form.querySelector(`.js-quick-add-option[data-option-index="${i}"][data-option-value="${optVal}"]`);
            if (btn) {
              form.querySelectorAll(`.js-quick-add-option[data-option-index="${i}"]`).forEach(b => b.classList.remove('is-active'));
              btn.classList.add('is-active');
            }
          });
          updateSubmitState();
        });
      });

      submitBtn.addEventListener('click', () => {
        const variantId = submitBtn.dataset.variantId;
        if (!variantId || submitBtn.disabled || this.classList.contains('is-requesting')) return;
        this.addVariantToCartFromModal(parseInt(variantId, 10), modalContainer);
      });

      submitWrap.appendChild(submitBtn);
      submitWrap.appendChild(unavailableEl);
      form.appendChild(submitWrap);

      updateSubmitState();
      return form;
    }

    addVariantToCartFromModal(variantId, modalContainer) {
      const sizeMessagesContainer = modalContainer.querySelector('.js-messages');
      const sizeMessageSuccess = modalContainer.querySelector('.js-success-message');
      const sizeMessageError = modalContainer.querySelector('.js-error-message');

      this.toggleBtns();

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);
      formData.append('properties[_added_via]', 'SHOP NU knop');
      formData.append('sections', this.cartDrawer?.getSectionsToRender()?.map(section => section.section) || []);
      if (window.location.pathname === '/cart') {
        const cartDrawerForm = document.getElementById('CartDrawer-FormSummary');
        if (cartDrawerForm) cartDrawerForm.submit();
      }
      formData.append('sections_url', window.location.pathname);

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then(res => res.json().then(data => ({ ok: res.ok, data })))
        .then(({ ok, data }) => {
          if (!ok) throw new Error(data.description || 'Something went wrong');
          sizeMessageSuccess?.classList.remove('hidden');
          sizeMessageError?.classList.add('hidden');
          if (this.cartDrawer) this.cartDrawer.renderContents(data, false);
          this.hideSizes(modalContainer);
          appendCartNote('Product toegevoegd via SHOP NU knop');
        })
        .catch(err => {
          const errorTextEl = sizeMessageError?.querySelector('[data-text]');
          if (errorTextEl) errorTextEl.textContent = err.message || 'Something went wrong';
          sizeMessageSuccess?.classList.add('hidden');
          sizeMessageError?.classList.remove('hidden');
        })
        .finally(() => {
          this.toggleBtns();
          if (sizeMessagesContainer) sizeMessagesContainer.classList.add('is-visible');
          setTimeout(() => sizeMessagesContainer?.classList.remove('is-visible'), 4000);
        });
    }

    sortOptionValues(optionName, values) {
      const name = (optionName || '').toLowerCase();
      const isSize = /size|maat|ring/.test(name);
      if (!isSize && values.length === 0) return values;
      const asNumbers = values.map(v => parseFloat(String(v).replace(',', '.')));
      const allNumeric = asNumbers.every(n => !Number.isNaN(n));
      if (allNumeric && (isSize || values.length > 0)) {
        return [...values].sort((a, b) => {
          const na = parseFloat(String(a).replace(',', '.'));
          const nb = parseFloat(String(b).replace(',', '.'));
          return na - nb;
        });
      }
      return [...values].sort((a, b) => String(a).localeCompare(String(b), undefined, { numeric: true }));
    }

    isOptionValueAvailable(product, optionIndex, value, selectedOptions) {
      const variants = product.variants || [];
      return variants.some(v => {
        if (!v.available) return false;
        const opts = v.options || [v.option1, v.option2, v.option3].filter(Boolean);
        if (opts[optionIndex] !== value) return false;
        for (let i = 0; i < optionIndex; i++) {
          if (selectedOptions[i] != null && opts[i] !== selectedOptions[i]) return false;
        }
        return true;
      });
    }

    normalizeProductOptions(product) {
      const raw = product.options || [];
      const variants = product.variants || [];
      const getValues = (i) => [...new Set(variants.map(v => v.options?.[i] ?? v[`option${i + 1}`]).filter(Boolean))];

      if (raw.length === 0 && variants.length > 0) {
        const first = variants[0];
        const n = first.options ? first.options.length : [first.option1, first.option2, first.option3].filter(Boolean).length;
        const fromVariants = [];
        for (let i = 0; i < n; i++) {
          const values = this.sortOptionValues(`Option ${i + 1}`, getValues(i));
          fromVariants.push({ name: `Option ${i + 1}`, values });
        }
        return fromVariants;
      }
      return raw.map((opt, i) => {
        let name = '';
        let values = [];
        if (typeof opt === 'object' && opt !== null && 'name' in opt) {
          name = opt.name;
          values = Array.isArray(opt.values) ? opt.values : getValues(i);
        } else {
          name = String(opt);
          values = getValues(i);
        }
        values = this.sortOptionValues(name, values);
        return { name, values };
      });
    }

    handleBtnSizeClick(e) {
      const isBtnSize = e.target.classList.contains('js-btn-size');

      if (!isBtnSize) {
        return;
      }

      const btnSize = e.target;
      const isDisabled = btnSize.classList.contains('is-disabled');
      const isRequesting = this.classList.contains('is-requesting');

      if (isRequesting || isDisabled) {
        return;
      }

      const selectedVariantIdFromBtn = btnSize.dataset.variantid;
      const clickedOnCard = btnSize.closest('.js-sizes-content') === this.sizesContent;
      const singleAddButtonOnCard = this.initialSizeBtns?.length === 1 && selectedVariantIdFromBtn;
      if (clickedOnCard && singleAddButtonOnCard) {
        this.getProduct().then(product => {
          const sizesContent = this.duplicatedSizesContainer?.querySelector(`.js-sizes-content[data-id="${this.btnToggleSizes?.dataset.id}"]`);
          if (product && product.variants && product.variants.length > 1 && sizesContent) {
            this.openQuickAddModal(sizesContent);
            return;
          }
          if (product && product.variants?.length === 1) {
            this.addVariantToCartFromModal(parseInt(selectedVariantIdFromBtn, 10), this.sizesContent);
          }
        });
        return;
      }

      const btnSwatchActive = this.querySelector(
        '.js-btn-swatch.is-active'
      );

      const selectedSize = btnSize.dataset.size;
      const selectedColor = btnSwatchActive?.dataset.color;

      const selectedVariantId = btnSize.dataset.variantid ? btnSize.dataset.variantid : undefined;

      const targetSizesContent = btnSize.closest('.js-sizes-content');
      const sizeMessagesContainer =
        targetSizesContent.querySelector('.js-messages');
      const sizeMessageSuccess = targetSizesContent.querySelector(
        '.js-success-message'
      );
      const sizeMessageError = targetSizesContent.querySelector(
        '.js-error-message'
      );

      this.toggleBtns();

      const addProductToCart = async () => {
        try {
          const product = await this.getProduct();

          const matchingVariant = product.variants.find(variant => {

            if (selectedVariantId) {
              const matchesVariantId = variant.id == selectedVariantId;
              return matchesVariantId;
            } else {
              const matchesSize =
                variant.options.includes(selectedSize);
              const matchesColor = btnSwatchActive
                ? variant.options.includes(selectedColor)
                : true;
              return matchesSize && matchesColor;
            }

          });

          if (!matchingVariant) {
            return;
          }

          const isAvailable = matchingVariant.available;

          if (!isAvailable) {
            return;
          }

          const formData = new FormData();
          formData.append('id', matchingVariant.id);
          formData.append('quantity', 1);
          formData.append(
            'sections',
            this.cartDrawer
              .getSectionsToRender()
              ?.map(section => section.section)
          );

          // if we are on the cart page, resubmit form
          if (window.location.pathname === '/cart') {
            const cartDrawerForm = document.getElementById('CartDrawer-FormSummary');
            if (cartDrawerForm) {
              cartDrawerForm.submit();
            }
          }

          formData.append('sections_url', window.location.pathname);

          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          config.body = formData;

          const addToCartResponse = await fetch(
            `${routes.cart_add_url}`,
            config
          );

          const addToCartData = await addToCartResponse.json();

          if (!addToCartResponse.ok) {
            throw new Error(addToCartData.description);
          }

          sizeMessageSuccess.classList.remove('hidden');
          sizeMessageError.classList.add('hidden');

          this.cartDrawer.renderContents(addToCartData, false);
        } catch (error) {
          const errorTextEl =
            sizeMessageError.querySelector('[data-text]');

          sizeMessageSuccess.classList.add('hidden');
          sizeMessageError.classList.remove('hidden');

          errorTextEl.textContent = error.message;
        } finally {
          this.toggleBtns();

          sizeMessagesContainer.classList.add('is-visible');
          setTimeout(() => {
            sizeMessagesContainer.classList.remove('is-visible');
          }, 4000);
        }
      };

      addProductToCart();
    }

    setAccessibility() {
      const duplicatedSizesContentId = `SizesPopup-${this.sizesContent.dataset.id}`;

      this.duplicatedSizesContent.id = duplicatedSizesContentId;
      this.btnToggleSizes.setAttribute('aria-expanded', false);
      this.btnToggleSizes.setAttribute(
        'aria-controls',
        duplicatedSizesContentId
      );
    }

    toggleBtns() {
      this.classList.toggle('is-requesting');
      this.btnSwatches?.forEach(btnSwatch =>
        btnSwatch.toggleAttribute('disabled')
      );

      if (!this.btnToggleSizes) {
        return;
      }

      this.sizesContent.classList.toggle('overlay-visible');
      this.duplicatedSizesContent.classList.toggle('overlay-visible');
    }

    showSizes(container) {
      this.btnToggleSizes.setAttribute('aria-expanded', true);
      container.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
      this.firstFocusableElement.focus();
    }

    hideSizes(container) {
      this.btnToggleSizes.setAttribute('aria-expanded', false);
      container.classList.remove('is-visible');
      document.body.style.overflow = '';
      this.btnToggleSizes.focus();
    }
  }

  customElements.define('card-product', CardProduct);
}

function appendCartNote(toevoegen) {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var huidig = cart.note || '';
      var nieuweNoot = huidig ? huidig + '\n' + toevoegen : toevoegen;
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: nieuweNoot })
      });
    })
    .catch(function() {});
}
